module.exports = __webpack_public_path__ + "static/media/img11.f3aa516e.jpg";